import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import UserProfilePopup from "./UserProfilePopup";
import "./Header.scss";
import { config } from "../../App";
import axios from "axios";
import TaxRegimeModal from "./TaxRegimeModal";

const Header = () => {

  const token = sessionStorage.getItem("token");
  const empId = sessionStorage.getItem("EmployeeID");
  const [showProfile, setShowProfile] = useState(false);
  const location = useLocation();
  const [taxRegimeType, setTaxRegimeType] = useState("");
  const [showTaxRegimeModal, setShowTaxRegimeModal] = useState(false);
  const userName = sessionStorage.getItem("username");

  const user = {
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    name: "Gundeep Malhotra",
    email: "gundeep.malhotra@spicejet.com",
    phone: "9999969423",
    employeeId: "500271",
    designation: "General Manager",
    department: "Information Technology",
    doj: "02 Dec 2015",
    shift: "daycorporateHQ",
    location: "Haryana"
  };


  const getGetTaxRegimeType = async () => {
    try {
      const response = await axios.get(
        `${config.endpoint}/payroll/GetTaxRegimeType?employeeId=${empId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      if (!data?.status) return;
      setTaxRegimeType(data.Data.TaxRegimeType);

    } catch (err) {
      console.error("fetch error:", err);
    } finally {
      //setLoading(false);
    }
  };

  const onClickHendler = async (val) => {
    const payload = {
      Username: empId,
      AppName: val
    }

    if (val === "investment" && taxRegimeType === "New Tax Regime") {
      setShowTaxRegimeModal(true);
    } else {
      try {
        const response = await axios.post(
          `${config.endpoint}/auth/Applogin`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response?.data?.Status) {
          const { Url, Token } = response.data;
          const ssoUrl = `${Url}?u=${empId}&t=${Token}&app=${val}`;

          //console.log("ssoUrl", ssoUrl);

          window.open(ssoUrl, "_blank");
        } else {
          console.error("API returned false status", response.data);
        }
      } catch (err) {
        console.error("API error:", err);
      }
    }

  }

  const handleModalClose = () => {
    setShowTaxRegimeModal(false);
  }

  useEffect(() => {
    getGetTaxRegimeType();
  }, [])

  return (
    <>
      <header className="p-4">
        <Container fluid>
          <Navbar expand="lg" className="ess-header">

            {/* Logo */}
            <NavLink to={`/dashboard`}>
              <img src="/images/logo.svg" alt="Spicejet" className="logo" />
            </NavLink>

            <Navbar.Collapse id="basic-navbar-nav">

              <Nav className="mx-auto middle-nav">

                {/* Dashboard */}
                <NavLink
                  to={`/dashboard`}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  Dashboard
                </NavLink>

                {/* Pay Roll */}
                <NavDropdown
                  title="Pay Roll"
                  className={
                    location.pathname.includes("paySlip") ||
                      location.pathname.includes("form16")
                      ? "active"
                      : ""
                  }
                >
                  <NavDropdown.Item
                    as={NavLink}
                    to={`/paySlip`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Pay Slip
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={NavLink}
                    to={`/form16`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Form 16
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={NavLink}
                    to={`/itComputation`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    IT Computation
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={NavLink}
                    to={`/reimbursementSlip`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Reimbursement Slip
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={NavLink}
                    to={`/appraisalLetter`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Appraisal Letter
                  </NavDropdown.Item>
                </NavDropdown>

                {/* Form */}
                {/* <NavDropdown title="Form">
                  <NavDropdown.Item
                    as={NavLink}
                    to={`/${config.baseUrl}/work-inprosess`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Form 16
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* HR Portal */}
                <NavDropdown title="HR Portal">
                  {/* <NavDropdown.Item
                    as={NavLink}
                    to={`/work-inprosess`}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    HR Policy
                  </NavDropdown.Item> */}

                  <NavDropdown.Item
                    as={NavLink}
                    to={``}
                    onClick={(e) => {
                      e.preventDefault();
                      onClickHendler("OPSPOSH");
                    }}
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Posh Portal
                  </NavDropdown.Item>
                </NavDropdown>

                {/* Employee Links */}
                <NavDropdown title="Employee’s Links" className="EmployeeLinks">
                  {[
                    { name: "Investment Declaration", requiresApi: true, appName: "investment" },
                    { name: "ELT Booking", path: "https://elt.spicejet.com/", isExternal: "_blank" },
                    { name: "SOD Booking", path: "https://sod.spicejet.com/", isExternal: "_blank" },
                    { name: "E-Sarahana", requiresApi: true, appName: "e-sarahana" },
                    { name: "Long Service Award", path: "https://longserviceawards.spicejet.com/", isExternal: "_blank" },
                    { name: "Spice Star", requiresApi: true, appName: "spicestar" },
                    { name: "Co-mail / Co-mat", path: "https://comail.spicejet.com/", isExternal: "_blank" },
                    // { name: "Reimbursement Slip", path: `/reimbursementSlip` },
                    // { name: "IT Computation", path: `/itComputation` },
                    // { name: "Appraisal Letter", path: `/appraisalLetter` },
                    { name: "Zoho", path: "https://people.zoho.com/spicejet/zp", isExternal: "_blank" },
                    // { name: "ID Card", requiresApi: true, appName: "idcard" },
                    // { name: "Taxregime", requiresApi: true, appName: "taxregime" },
                    // { name: "AVSEC", requiresApi: true, appName: "avsec" },
                  ].map((item, i) => (
                    <NavDropdown.Item
                      key={i}
                      as={NavLink}
                      to={item.requiresApi ? "" : item.path}
                      target={item.isExternal}
                      onClick={(e) => {
                        if (item.requiresApi) {
                          e.preventDefault();
                          onClickHendler(item.appName);
                        }
                      }}
                      className={({ isActive }) =>
                        isActive
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {item.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

              </Nav>

            </Navbar.Collapse>

            <div className="d-flex gap-4">
              {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggle">
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </Navbar.Toggle>

              {/* Profile */}
              <div
                className="profile-box"
                onClick={() => setShowProfile(true)}
              >
                <img
                  src="/images/blank-profile.png"
                  alt=""
                />
                <span>{userName}</span>
              </div>
            </div>
          </Navbar>
        </Container>
      </header>

      <UserProfilePopup
        show={showProfile}
        handleClose={() => setShowProfile(false)}
        user={user}
      />

      <TaxRegimeModal
        isOpen={showTaxRegimeModal}
        onClose={handleModalClose}
        taxRegimeType={taxRegimeType}
      />
    </>
  );
};

export default Header;